import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4 mt-5">
      <Container>
        <Row>
          <Col md={6}>
            <h5>Nicer Lawns</h5>
            <p className="text-muted small">Professional landscaping services — Kansas City</p>
            <p className="mb-0 small">(816) 352-1651</p>
            <div className="mt-2">
              <a className="text-light me-3 small" href="#">Facebook</a>
              <a className="text-light me-3 small" href="#">Instagram</a>
              <a className="text-light small" href="#">Gallery</a>
            </div>
          </Col>
          <Col md={6} className="text-md-end mt-3 mt-md-0">
            <p className="small mb-0">© {new Date().getFullYear()} Nicer Lawns. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
